import React, { ChangeEvent, useContext } from 'react'
import UserContext, { UserContextType } from './UserContext'

import { jsonVersions } from './constants'

const VersionSettings = () => {
  const {
    userContext: { version },
    setVersion,
  } = useContext(UserContext) as UserContextType

  const onVersionChanged = (event: ChangeEvent<HTMLSelectElement>) => {
    setVersion(event.target.value)
  }
  return (
    <div className="mint-settings">
      <div className="setting">
        <label>Version:</label>
        <select defaultValue={version} onChange={onVersionChanged}>
          {jsonVersions.map((versionOption) => (
            <option key={versionOption} value={versionOption}>
              {versionOption}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

export default VersionSettings
